import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=4b9c2ebc&scoped=true&"
import script from "./NotFound.vue?vue&type=script&lang=js&"
export * from "./NotFound.vue?vue&type=script&lang=js&"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=4b9c2ebc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9c2ebc",
  null
  
)

component.options.__file = "NotFound.vue"
export default component.exports